function range(start, end) {
    var ans = [];
    for (let i = start; i <= end; i++) {
        ans.push(i);
    }
    return ans;
}


function proximaPregunta(Preguntas, Actual){


    let longitudFormulario = Preguntas.length;

    let posiblesPreguntas = range((Actual+1), (longitudFormulario-1));


    for (let posible of posiblesPreguntas)
    {

        let SiguientePregunta = Preguntas[posible];
        let EsVisible = SiguientePregunta["show"];

        if (EsVisible == true)
        {

            return posible;

        }
        

    }


    return false;

}

function previaPregunta(Preguntas, Actual){


    let longitudFormulario = Preguntas.length;

    var posiblesPreguntas = range(0, (Actual-1));

    posiblesPreguntas.reverse();

    for (let posible of posiblesPreguntas)
    {

        let SiguientePregunta = Preguntas[posible];
        let EsVisible = SiguientePregunta["show"];


        if (EsVisible == true)
        {

            return posible;

        }
        

    }


    return false;

}

exports.proximaPregunta = proximaPregunta;
exports.previaPregunta = previaPregunta;